import React from 'react';
import { useNavigate } from 'react-router-dom';
import ProfileCard from '../components/ProfileCard';
import blueImage from '../images/blue.png';
import greyImage from '../images/grey.png';
import redImage from '../images/red.png';
import yellowImage from '../images/yellow.png';
import './browse.css';

const Browse: React.FC = () => {
  const navigate = useNavigate();

  const profiles = [
    {
      id: "recruiter",
      label: "Recruiter",
      image: blueImage,
    },
    {
      id: "developer",
      label: "Developer",
      image: greyImage,
    },
    {
      id: "stalker",
      label: "Stalker",
      image: redImage,
    },
    {
      id: "adventure",
      label: "Adventurer",
      image: yellowImage,
    },
  ];

  const handleProfileClick = (profile: { id: string; image: string }) => {
    navigate(`/profile/${profile.id}`, { state: { profileImage: profile.image } });
  };

  return (
    <div className="browse-container">
      <p className='who-is-watching'>Who's Watching?</p>
      <div className="profiles">
        {profiles.map((profile, index) => (
          <ProfileCard
            key={index}
            name={profile.label}
            image={profile.image}
            onClick={() => handleProfileClick(profile)}
          />
        ))}
      </div>
    </div>
  );
};

export default Browse;
